import React from 'react';
import Chart from "react-apexcharts";
import moment from 'moment';

const Barchart = ({ dates, data }) => {
  const chartOptions = {
    chart: {
      type: 'bar',
      height: 280,
      toolbar: {
        show: false
      }
    },
    plotOptions: {
      bar: {
        borderRadius: 5,
        columnWidth: "30%", // Adjusted to match design
      },
    },
    fill: {
      colors: ['#1DBF73']
    },
    colors: ['#1DBF73'],
    dataLabels: {
      enabled: false // Removed labels inside bars
    },
    yaxis: {
      show: true,
      title: {
        text: 'Number of Items'
      },
      labels: {
        formatter: (val) => Math.floor(val) // Round values if needed
      }
    },
    xaxis: {
      categories: dates.map(date => moment(date).format('DD-MM-YYYY')),
      labels: {
        rotate: 0, // Prevents text rotation
        trim: false
      }
    },
    grid: {
      show: true, // Ensures Y-axis gridlines
    },
  };

  const series = [{
    name: 'Total Items',
    data: data.map(arr => arr.length)
  }];

  return (
    <div className="w-full">
      <Chart
        options={chartOptions}
        series={series}
        type="bar"
        className="chart-class"
        height={285}
      />
    </div>
  );
};

export default Barchart;
